import { AxiosRequest } from "../../../Url";
import { getRightsData } from "../../Tools/Tools";
import { payTypesSettingsColumns } from "./Columns/payTypesColumns";
import { createGrid, createRecordSource } from "../rcsgrid";

export async function payTypesSettingsGrid(grid: createGrid, source: createRecordSource, props, data) {
  source.onHandleRequest = handleRequestForPayTypesSettings(props);

  await source.open();

  grid.setColumns(payTypesSettingsColumns);
  source.rights = getRightsData("-1");

  if (data.setSelectedRecord) {
    source.onRecordIndexChanged = async (source) => {
      data.setSelectedRecord(source.getFieldValueSync("Code"));
    };
  }

  source.first();

  await grid.setSource(source);

  if (props.ID) await grid.refreshSource(props.ID);

  data.setSelectedRecord?.(source.getFieldValueSync("Code"));
  await grid.updateGridSize();
}

function handleRequestForPayTypesSettings(props) {
  return function onHandleRequest(request) {
    const params = new Map();
    params
      .set("prefix", props.Module)
      .set("comand", "HandleTable")
      .set("ObjType", props.ObjType)
      .set("SectionID", props.SectionID);
    return AxiosRequest(true, params, request);
  };
}
